import React from 'react'

import { Button, Dropdown, TableComponents } from '@sketch/components'

import {
  MethodWrapper,
  Provider,
  MethodIdentifier,
  ActionCell,
  AppleIcon,
  Dots,
  Arrow,
} from './SignInMethods.styles'

import { GetUserSettingsQuery } from '@sketch/gql-types'

const { TableRow, TableCell } = TableComponents

type SocialAccount = GetUserSettingsQuery['me']['socialAccounts'][0]

interface AppleRowProps {
  account?: SocialAccount
  canRemove: boolean
  isLoading: boolean
  onManageAccount: () => void
  onAddAccount: () => void
  onRemove?: () => void
}

export const AppleRow: React.FC<AppleRowProps> = ({
  account,
  canRemove,
  isLoading,
  onManageAccount,
  onAddAccount,
  onRemove,
}) => {
  return (
    <TableRow>
      <TableCell>
        <MethodWrapper>
          <AppleIcon />
          <Provider>Apple</Provider>
        </MethodWrapper>
      </TableCell>
      <TableCell>
        <ActionCell>
          {account?.email && (
            <MethodIdentifier>{account.email}</MethodIdentifier>
          )}
          {account ? (
            <Dropdown
              usePortal
              placement="bottom-end"
              toggle={
                <Button variant="secondary" size="40">
                  <Dots />
                </Button>
              }
            >
              <Dropdown.Item onClick={onManageAccount}>
                Manage Sign in with Apple <Arrow />
              </Dropdown.Item>
              {canRemove && onRemove && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item intent="negative" onClick={onRemove}>
                    Remove&hellip;
                  </Dropdown.Item>
                </>
              )}
            </Dropdown>
          ) : (
            <Button
              variant="secondary"
              size="40"
              onClick={onAddAccount}
              loading={isLoading}
            >
              Add Account
            </Button>
          )}
        </ActionCell>
      </TableCell>
    </TableRow>
  )
}
